(ns ycweb.app.website.dlp.widgets.semisoluscards
  (:require
   [clojure.string :as str]
   [rum.core :as rum]
   [ycweb.app.website.common :as web-common]
   [ycweb.components.scroll :as scroll]
   [ycweb.util.core :as u]
   [ycweb.util.urlstate :as urlstate]))

(rum/defc build-semisolus-card < rum/reactive [app-atom card]
  (let [{:cards/keys
         [banner-background-colour url on-page-link picture-public-id image-alt
          title-highlighted title pretext]} card

        dark?
        (and
          (u/presence banner-background-colour)
          (not (:banner-background-colour/text-dark banner-background-colour)))]

    [:div
     {:class (u/bem :flex-grid-block [:m-1-2])}
     [:article.flex-grid-content.card
      {:class
       (u/bem
         :semisolus-card [(when-not picture-public-id "has-no-image")]
         (when banner-background-colour (str "u-bg-" (:banner-background-colour/colour-name banner-background-colour)))
         (when dark? "u-text-white"))}
      [:a.semisolus-card__link.group
       (merge
         (when on-page-link
           (urlstate/href-on-click #(scroll/scroll-to-id % (str/replace url #"\#" ""))))
         {:href url})
       (when picture-public-id
         [:div.semisolus-card__hero
          (web-common/lazy-image app-atom
            picture-public-id
            {:class ["yc-simple-image  yc-simple-image--full"]}
            {:w 318
             :mw 318
             :q "auto"
             :alt
             (cond
               image-alt
               image-alt

               (and pretext title-highlighted)
               (str pretext ": " title-highlighted)

               :else
               (str title-highlighted " " title))})])
       [:div.semisolus-card__content
        [:h2.semisolus-card__title
         (when pretext
           [:span.semisolus-card__pre-title
            pretext
            [:span.u-hidden-from-view ":"]])
         (when title-highlighted
           [:span.semisolus-card__title-highlight
            {:dangerouslySetInnerHTML
             {:__html title-highlighted}}])

         [:b title]]]
       [:div.semisolus-card__icon-wrap
        [:i.semisolus-card__icon
         {:class (u/bem :icon [:block :arrow-right (if dark? "is-light" "is-dark")])}]]]]]))

(rum/defc semisolus-cards < rum/reactive [app-atom _ {:keys [properties]}]
  (let [{:semisolus-cards/keys [cards on-page-link-id]} properties]
    [:div.yc-section
     {:id (when on-page-link-id on-page-link-id)}
     [:<>
      [:div.flex-grid-group
       (->>
         cards
         (map #(build-semisolus-card app-atom %)))]]]))
